import { type QuoteCardProps } from 'components/QuoteCard';
import { type ShapeCardProps } from 'components/ShapeCard';
import { type ImageType } from 'utils/types';

export const parseShapeCards = (section: Queries.ContentfulSection001) => {
  const { title, description, flags } = section.metadata ?? {};
  const isQuoteCards =
    flags?.find((flag) => flag?.displayName === 'isQuoteCards')?.value === true;
  const isQuotesV2 =
    flags?.find((flag) => flag?.displayName === 'newPdp')?.value === true;

  const subsections =
    (section?.subsections as Queries.ContentfulSection001[]) || [];

  const shapeCardsData: ShapeCardProps[] = subsections
    .filter((subsection) => subsection.componentName === 'ShapeCard')
    .map((subsection) => {
      const { eyebrow } = subsection ?? {};
      const { title, ctas } = subsection.metadata ?? {};
      let desktopImage: ImageType | null = null;
      let mobileImage: ImageType | null = null;

      if (subsection?.images && subsection.images.length > 0) {
        if (subsection.images[0]?.desktopImage?.gatsbyImageData) {
          desktopImage = {
            gatsbyImageData:
              subsection.images[0]?.desktopImage?.gatsbyImageData,
            description: subsection.images[0]?.desktopImageAltText || '',
          };
        }

        if (subsection.images[0]?.mobileImage?.gatsbyImageData) {
          mobileImage = {
            gatsbyImageData: subsection.images[0]?.mobileImage?.gatsbyImageData,
            description: subsection.images[0]?.mobileImageAltText || '',
          };
        }
      }

      const shapeCard: ShapeCardProps = {
        tagText: eyebrow ?? '',
        headingText: title ?? '',
        bottomText: {
          raw: subsection?.body?.raw || '',
        },
        bottomTextAuthor: subsection?.metadata?.description?.description ?? '',
        desktopImage,
        mobileImage,
        cta: {
          label: ctas?.[0]?.label || '',
          url: ctas?.[0]?.url || '',
        },
        backgroundColor: subsection?.metadata?.theme?.backgroundColor || '',
        textColor: subsection?.metadata?.theme?.textColor || '',
      };

      return shapeCard;
    });

  const quoteCards = subsections
    .filter((subsection) => subsection.componentName === 'QuoteCard')
    .map((subsection) => {
      const quoteCard: QuoteCardProps = {
        text: {
          raw: subsection?.body?.raw || '',
        },
        author: subsection?.metadata?.description?.description ?? '',
        backgroundColor: subsection?.metadata?.theme?.backgroundColor || '',
        textColor: subsection?.metadata?.theme?.textColor || '',
        quoteIconColor: subsection?.metadata?.theme?.secondaryColor || '',
      };

      return quoteCard;
    });

  return {
    eyebrow: section?.eyebrow ?? '',
    title: title ?? '',
    disclaimer: description?.childMarkdownRemark?.html ?? '',
    shapeCardsData: shapeCardsData,
    isQuoteCards,
    isQuotesV2,
    quoteCards,
  };
};
